import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';
export const REFERRAL_KEY_PREFIX = ['referrals'];

const referralListKey = [...REFERRAL_KEY_PREFIX, 'list']

const useReferral = () => useQuery(
        referralListKey,
        () => apiClient.get('/SubAffiliate/').then(r => r.data),
        { staleTime: 5 * 60 * 1000 }
    )
;



export default useReferral;